import React from 'react';

import SatDataGrid from '@components/common/satUI/SatDataGrid';
import SatPagination from '@components/common/satUI/SatPagination';

const UseList = props => {

    const {          
        useColumns,
        useList,
        statsUseTotalCount,
        excelDown,
        usePageChange,
        initial
    } = props;

    return (
        <React.Fragment>
            <div className="table-wrap-reg">
                <div className="tit-mini mgt-20">전체 {statsUseTotalCount}건</div> 
                <div className="table-wrap">
                    <SatDataGrid
                        columns={useColumns}
                        dataSource={useList}
                        noDataRender={'검색결과가 없습니다.'}
                        customStyleClass={'depth1'}
                    />   
                </div>
                
                <SatPagination initial={initial} totalCount={statsUseTotalCount} onChange={usePageChange} />

                <div className="btn-r-fix">
                    <button onClick={() => excelDown('use')}>
                        <span className="ico ico-exl-down"></span>
                        엑셀 다운로드
                    </button>
                </div>
            </div>
        </React.Fragment>
    );

};

export default UseList;